import { dataroomApi, lexApi } from './client';

export type LexDocument = {
  id: string;
  name: string;
  updatedAt: string;
  caseId?: string | null;
  caseName?: string | null;
  mimeType?: string | null;
  sizeBytes?: number | null;
};

export type ContractTemplate = {
  id: string;
  name: string;
  description?: string | null;
  jurisdiction?: string | null;
  variables?: string[];
};

export type ContractClause = {
  id: string;
  title: string;
  body: string;
  jurisdiction?: string | null;
};

const unwrap = <T>(payload: any): T =>
  payload?.data?.data ?? payload?.data ?? payload;

export async function searchDocuments(query: string): Promise<LexDocument[]> {
  const res = await lexApi.get('/office-addin/documents', {
    params: { q: query, take: 25 },
  });
  return unwrap<LexDocument[]>(res);
}

const DOCX_MIME =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export async function downloadDocument(id: string): Promise<ArrayBuffer> {
  const intent = await dataroomApi.get<{ downloadUrl: string }>(
    `/documents/${id}/download`,
  );
  const { downloadUrl } = intent.data;
  const res = await fetch(downloadUrl);
  if (!res.ok) {
    throw new Error(`Download failed (${res.status})`);
  }
  return await res.arrayBuffer();
}

export async function uploadNewVersion(
  id: string,
  data: ArrayBuffer,
  filename: string,
  comments?: string,
): Promise<void> {
  const blob = new Blob([data], { type: DOCX_MIME });
  const form = new FormData();
  form.append('file', blob, filename);
  if (comments) form.append('comments', comments);
  await dataroomApi.post(`/documents/${id}/upload-version`, form);
}

export async function listTemplates(): Promise<ContractTemplate[]> {
  const res = await lexApi.get('/office-addin/contract-templates');
  return unwrap<ContractTemplate[]>(res);
}

export async function listClauses(
  jurisdiction?: string,
): Promise<ContractClause[]> {
  const res = await lexApi.get('/office-addin/contract-clauses', {
    params: jurisdiction ? { jurisdiction } : undefined,
  });
  return unwrap<ContractClause[]>(res);
}
